import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import type { BaseService } from '@essent/common';
import { snakeCase, toHttpParams } from '@essent/common';
import { API_PREFIX } from '@core/config-angular';
import { type Observable } from 'rxjs';
import {
  type GetProductsRequestQuery,
  type GetProductsRequestResponse,
} from '@innogy/feh/models';

@Injectable()
export class GetStoreProductsService
  implements BaseService<GetProductsRequestQuery, GetProductsRequestResponse>
{
  private readonly apiUrl: string | null = inject(API_PREFIX, {
    optional: true,
  });
  private readonly httpClient = inject(HttpClient);

  public readonly apiVersion = '1';
  public readonly endpoint = `${this.apiUrl || ''}/eplus/store/products/v${
    this.apiVersion
  }`;

  public call$(
    payload: GetProductsRequestQuery
  ): Observable<GetProductsRequestResponse> {
    const headers = { Accept: 'application/json' };
    const params = toHttpParams(snakeCase(payload));

    return this.httpClient.get<GetProductsRequestResponse>(this.endpoint, {
      headers,
      params,
    });
  }
}
